enum AwardCategory {
  PROFESSIONAL_DESIGNATION = 'Professional designation',
  ACADEMIC_HONOR = 'Academic honor',
}

export default AwardCategory;
